module.exports = __webpack_public_path__ + "img/view3d-notice-1.28d75de2.png";